import { render, staticRenderFns } from "./WithdrawRecord.vue?vue&type=template&id=ef518244&scoped=true"
import script from "./WithdrawRecord.vue?vue&type=script&lang=js"
export * from "./WithdrawRecord.vue?vue&type=script&lang=js"
import style0 from "./WithdrawRecord.vue?vue&type=style&index=0&id=ef518244&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef518244",
  null
  
)

export default component.exports